// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { agentRuntimeKindGuard, agentRuntimeInstanceStatusGuard, jsonObjectGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    agentId: z.string().min(1).max(21),
    keyId: z.string().min(1).max(21),
    runtime: agentRuntimeKindGuard,
    externalInstanceHash: z.string().min(1).max(64),
    displayName: z.string().max(128).nullable().optional(),
    status: agentRuntimeInstanceStatusGuard.optional(),
    metadata: jsonObjectGuard.optional(),
    activatedAt: z.number().nullable().optional(),
    lastSeenAt: z.number().nullable().optional(),
    revokedAt: z.number().nullable().optional(),
    createdAt: z.number().optional(),
    updatedAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    agentId: z.string().min(1).max(21),
    keyId: z.string().min(1).max(21),
    runtime: agentRuntimeKindGuard,
    externalInstanceHash: z.string().min(1).max(64),
    displayName: z.string().max(128).nullable(),
    status: agentRuntimeInstanceStatusGuard,
    metadata: jsonObjectGuard,
    activatedAt: z.number().nullable(),
    lastSeenAt: z.number().nullable(),
    revokedAt: z.number().nullable(),
    createdAt: z.number(),
    updatedAt: z.number(),
});
export const AgentRuntimeInstances = Object.freeze({
    table: 'agent_runtime_instances',
    tableSingular: 'agent_runtime_instance',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        agentId: 'agent_id',
        keyId: 'key_id',
        runtime: 'runtime',
        externalInstanceHash: 'external_instance_hash',
        displayName: 'display_name',
        status: 'status',
        metadata: 'metadata',
        activatedAt: 'activated_at',
        lastSeenAt: 'last_seen_at',
        revokedAt: 'revoked_at',
        createdAt: 'created_at',
        updatedAt: 'updated_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'agentId',
        'keyId',
        'runtime',
        'externalInstanceHash',
        'displayName',
        'status',
        'metadata',
        'activatedAt',
        'lastSeenAt',
        'revokedAt',
        'createdAt',
        'updatedAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
